// @flow

export { default } from './SimpleTable';
export {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeadCell,
  TableRow,
} from './parts';
